import { gql } from '@apollo/client';

export const fetchCampaignByIdQuery = gql`
  query getCampaign($id: Long!) {
    campaign(id: $id) {
      name
      id
      messageMedium
      startAt
      endedAt
      createdAt
      updatedAt
      defaultTimeZone
      campaignTypeDefinition
      labels {
        id
        name
      }
      lists {
        id
        name
      }
      templateId
      campaignState
      conversions {
        events {
          name
        }
      }
      customConversion {
        eventName
        valueField
      }
      experiments {
        id
        name
        variations {
          id
          name
          contentId
          templateId
          experimentId
        }
      }
      mobileAppIds
      campaignAlertsEnabled
    }
  }
`;

export const fetchExperimentVariants = gql`
  query getExperimentVariants($id: Long!) {
    experiment(id: $id) {
      variations {
        id
        name
        contentId
        templateId
        experimentId
      }
    }
  }
`;

export const fetchCampaignLabels = gql`
  query getCampaignLabels {
    campaignLabels {
      name
      id
    }
  }
`;

export const fetchTemplateByIdQuery = gql`
  query getTemplate($id: Long!) {
    template(id: $id) {
      name
      id
      contentId
    }
  }
`;

export const fetchCurrentProject = gql`
  query getCurrentProject {
    currentProject {
      showRevenue
    }
  }
`;

export const fetchMockSnippetsByCampaignId = gql`
  query getSnippetsByCampaignId(
    $campaignId: Long!
    $startDate: Long!
    $endDate: Long!
    $pagination: Pagination!
    $sort: Sort!
    $search: String!
    $templateId: Long!
  ) {
    snippetsByCampaignId(
      campaignId: $campaignId
      startDate: 456
      endDate: 456
      pagination: $pagination
      sort: $sort
      search: $search
      templateId: $templateId
    ) {
      info {
        count
        offset
        limit
        page
      }
      results {
        id
        snippetName
        parentSnippet
        metrics {
          TotalSent
          TotalClicks
          UniqueClicks
          ClickRate
        }
        links {
          total
          data {
            id
            url
            variations {
              total
              data {
                dynamicUrl
                metrics {
                  TotalClicks
                  UniqueClicks
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const fetchCampaignReplyStatsOverviewQuery = gql`
  query getCampaignReplyStatsOverview(
    $campaignId: Long!, 
    $startTime: Instant!, 
    $endTime: Instant!, 
    $templateId: Long!, 
    $locale: String
  ) {
    campaignReplyStatsOverview(
      campaignId: $campaignId
      startTime: $startTime
      endTime: $endTime
      templateId: $templateId
      locale: $locale
    ) {
      totalReplies
      totalQuickReplies
      totalCustomReplies
    }
  }
`;

export const fetchCampaignQuickRepliesQuery = gql`
  query getCampaignQuickReplies(
    $campaignId: Long!, 
    $startTime: Instant!, 
    $endTime: Instant!, 
    $templateId: Long!, 
    $locale: String
  ) {
    campaignQuickReplies(
      campaignId: $campaignId
      startTime: $startTime
      endTime: $endTime
      templateId: $templateId
      locale: $locale
    ) {
      totalQuickReplies
      quickReplyStats {
        name
        count
      }
    }
  }
`;

export const fetchCampaignCustomRepliesQuery = gql`
  query getCampaignCustomReplies(
    $campaignId: Long!, 
    $startTime: Instant!, 
    $endTime: Instant!, 
    $templateId: Long!, 
    $locale: String
  ) {
    campaignCustomReplies(
      campaignId: $campaignId
      startTime: $startTime
      endTime: $endTime
      templateId: $templateId
      locale: $locale
    ) {
        messageType
        messageText
        messageUrl
        userEmail
        createdAt
    }
  }
`;
